/**

 * Matrice route → screenId → titres aide — BT-028-R1 / BT-028-R2 (source de vérité tests + docs).

 */

export const HELP_ROUTE_MATRIX = [

  { route: "/", screenId: "public-home", titleFr: "Aide — Accueil public", titleEn: "Help — Public home" },

  { route: "/accueil", screenId: "connected-home", titleFr: "Aide — Accueil", titleEn: "Help — Home" },

  { route: "/connexion", screenId: "login", titleFr: "Aide — Connexion", titleEn: "Help — Sign in" },

  { route: "/demande-compte", screenId: "account-request", titleFr: "Aide — Demande de compte", titleEn: "Help — Account request" },

  { route: "/devenir-membre", screenId: "become-member", titleFr: "Aide — Devenir membre", titleEn: "Help — Become a member" },

  { route: "/calendrier", screenId: "public-calendar", titleFr: "Aide — Calendrier général", titleEn: "Help — General calendar" },

  { route: "/black-dragon", screenId: "public-black-dragon", titleFr: "Aide — Black Dragon public", titleEn: "Help — Public Black Dragon" },

  { route: "/confidentialite", screenId: "confidentialite", titleFr: "Aide — Politique de confidentialité", titleEn: "Help — Privacy Policy" },

  { route: "/contact", screenId: "contact", titleFr: "Aide — Contact", titleEn: "Help — Contact" },

  { route: "/formation", screenId: "formation", titleFr: "Aide — Formation", titleEn: "Help — Training" },

  { route: "/aide", screenId: "aide", titleFr: "Aide — Centre d'aide", titleEn: "Help — Help center" },

  { route: "/mes-informations", screenId: "mes-informations", titleFr: "Aide — Mon profil", titleEn: "Help — My profile" },

  { route: "/admin", screenId: "admin-dashboard", titleFr: "Aide — Tableau de bord admin", titleEn: "Help — Admin dashboard" },

  { route: "/admin/lancement-1er-septembre", screenId: "launch-cockpit", titleFr: "Aide — Cockpit lancement 1er septembre", titleEn: "Help — September 1 launch cockpit" },

  { route: "/hanshi/instructeurs", screenId: "admin-instructors", titleFr: "Aide — Gestion instructeurs", titleEn: "Help — Instructor management" },

  { route: "/admin/instructeurs", screenId: "admin-instructors", titleFr: "Aide — Gestion instructeurs", titleEn: "Help — Instructor management" },

  { route: "/admin/instructors", screenId: "admin-instructors", titleFr: "Aide — Gestion instructeurs", titleEn: "Help — Instructor management" },

  { route: "/admin/dojos", screenId: "admin-dojos", titleFr: "Aide — Gestion dojos", titleEn: "Help — Dojo management" },

  { route: "/hanshi/membres", screenId: "admin-students", titleFr: "Aide — Gestion étudiants", titleEn: "Help — Student management" },
  { route: "/admin/etudiants", screenId: "admin-students", titleFr: "Aide — Gestion étudiants", titleEn: "Help — Student management" },

  { route: "/admin/assistants", screenId: "admin-assistants", titleFr: "Aide — Assistants / Sempai", titleEn: "Help — Assistants / Sempai" },

  { route: "/admin/parents", screenId: "admin-parents", titleFr: "Aide — Gestion parents", titleEn: "Help — Parent management" },

  { route: "/admin/membres-officiels", screenId: "admin-official-members", titleFr: "Aide — Membres officiels CKA", titleEn: "Help — Official CKA members" },

  { route: "/admin/import", screenId: "admin-import", titleFr: "Aide — Import CSV", titleEn: "Help — CSV import" },

  { route: "/admin/presentation-interactive", screenId: "admin-presentation-interactive", titleFr: "Aide — Présentation interactive", titleEn: "Help — Interactive presentation" },

  { route: "/admin/documents", screenId: "admin-documents", titleFr: "Aide — Gestion documents", titleEn: "Help — Document management" },

  { route: "/admin/organisation", screenId: "admin-organisation", titleFr: "Aide — Organisation", titleEn: "Help — Organisation" },

  { route: "/admin/classes", screenId: "admin-classes", titleFr: "Aide — Classes / cours", titleEn: "Help — Classes / courses" },

  { route: "/admin/evenements", screenId: "admin-events", titleFr: "Aide — Événements", titleEn: "Help — Events" },

  { route: "/admin/presences", screenId: "admin-attendance", titleFr: "Aide — Présences", titleEn: "Help — Attendance" },

  { route: "/admin/progression", screenId: "admin-progression", titleFr: "Aide — Progression / ceintures / examens", titleEn: "Help — Progress / belts / exams" },

  { route: "/admin/ceintures", screenId: "admin-progression", titleFr: "Aide — Progression / ceintures / examens", titleEn: "Help — Progress / belts / exams" },

  { route: "/admin/examens", screenId: "admin-progression", titleFr: "Aide — Progression / ceintures / examens", titleEn: "Help — Progress / belts / exams" },

  { route: "/admin/comptes", screenId: "admin-accounts", titleFr: "Aide — Comptes", titleEn: "Help — Accounts" },

  { route: "/admin/preparation-liste-officielle", screenId: "admin-official-list-prep", titleFr: "Aide — Préparation liste officielle", titleEn: "Help — Official List Preparation" },

  { route: "/admin/roles", screenId: "admin-roles", titleFr: "Aide — Rôles", titleEn: "Help — Roles" },

  { route: "/admin/demandes", screenId: "admin-requests", titleFr: "Aide — Demandes de compte", titleEn: "Help — Account requests" },

  { route: "/admin/communications", screenId: "admin-communications", titleFr: "Aide — Communications", titleEn: "Help — Communications" },

  { route: "/admin/shotokan-black-dragon", screenId: "admin-shotokan", titleFr: "Aide — Shotokan Black Dragon", titleEn: "Help — Shotokan Black Dragon" },

  { route: "/admin/shotokan-black-dragon/documents-preuves", screenId: "admin-documents-preuves", titleFr: "Aide — Documents & Preuves", titleEn: "Help — Documents & Evidence" },

  { route: "/admin/shotokan-black-dragon/documents-preuves/import", screenId: "admin-documents-preuves-import", titleFr: "Aide — Import contrôlé", titleEn: "Help — Controlled import" },

  { route: "/sensei", screenId: "sensei-dashboard", titleFr: "Aide — Espace Sensei", titleEn: "Help — Sensei space" },

  { route: "/sempai", screenId: "sempai-dashboard", titleFr: "Aide — Espace Sempai", titleEn: "Help — Sempai space" },

  { route: "/mon-espace", screenId: "student-dashboard", titleFr: "Aide — Mon espace étudiant", titleEn: "Help — My student space" },

  { route: "/mes-cours", screenId: "student-classes", titleFr: "Aide — Mes cours", titleEn: "Help — My classes" },

  { route: "/mes-evenements", screenId: "student-events", titleFr: "Aide — Mes événements", titleEn: "Help — My events" },

  { route: "/ma-progression", screenId: "student-progress", titleFr: "Aide — Ma progression", titleEn: "Help — My progress" },

  { route: "/mes-titres", screenId: "student-titles", titleFr: "Aide — Mes titres", titleEn: "Help — My titles" },

  { route: "/mes-documents", screenId: "student-documents", titleFr: "Aide — Mes documents", titleEn: "Help — My documents" },

  { route: "/parent", screenId: "parent-dashboard", titleFr: "Aide — Espace Parent", titleEn: "Help — Parent space" },

  { route: "/parent/mes-enfants", screenId: "parent-children", titleFr: "Aide — Mes enfants", titleEn: "Help — My children" },

  { route: "/parent/horaires", screenId: "parent-schedule", titleFr: "Aide — Horaires", titleEn: "Help — Schedule" },

  { route: "/parent/evenements", screenId: "parent-events", titleFr: "Aide — Événements", titleEn: "Help — Events" },

  { route: "/parent/progression", screenId: "parent-progress", titleFr: "Aide — Progression", titleEn: "Help — Progress" },

  { route: "/parent/documents", screenId: "parent-documents", titleFr: "Aide — Documents", titleEn: "Help — Documents" },

  { route: "/parent/communications", screenId: "parent-comms", titleFr: "Aide — Communications", titleEn: "Help — Communications" },

  { route: "/mon-adhesion", screenId: "member-adhesion", titleFr: "Aide — Mon adhésion", titleEn: "Help — My membership" },

  { route: "/mon-calendrier", screenId: "member-calendar", titleFr: "Aide — Mon calendrier", titleEn: "Help — My calendar" },

  { route: "/mes-examens", screenId: "member-exams", titleFr: "Aide — Mes examens", titleEn: "Help — My exams" },

  { route: "/espace-black-dragon", screenId: "member-black-dragon", titleFr: "Aide — Espace Black Dragon", titleEn: "Help — Black Dragon space" },

  { route: "/parent/adhesion", screenId: "parent-membership", titleFr: "Aide — Adhésion enfants", titleEn: "Help — Children membership" },

  { route: "/admin/membres-officiels", screenId: "admin-official-members", titleFr: "Aide — Membres officiels CKA", titleEn: "Help — Official CKA members" },

  { route: "/admin/black-dragon-adhesions", screenId: "admin-black-dragon-membership", titleFr: "Aide — Adhésions Black Dragon", titleEn: "Help — Black Dragon memberships" },

];



/** Routes uniques pour tests DOM (sans alias duplicate instructors). */

export const MAIN_PHASE1_ROUTES = [...new Set(HELP_ROUTE_MATRIX.map((r) => r.route))];



export const HELP_FALLBACK_SCREEN_ID = "__fallback__";



/** Cas de test DOM — route, auth, testId page principale. */

export const PHASE1_DOM_ROUTE_CASES = [

  { route: "/", auth: null },

  { route: "/connexion", auth: null },

  { route: "/formation", auth: null, testId: "page-formation" },

  { route: "/aide", auth: { username: "etudiant", role: "student" }, testId: "page-aide" },

  { route: "/mes-informations", auth: { username: "etudiant", role: "student" }, testId: "page-mes-informations" },

  { route: "/admin", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-hanshi" },

  { route: "/admin/lancement-1er-septembre", auth: { username: "admin", role: "hanshi" }, testId: "page-launch-cockpit" },

  { route: "/admin/import", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-import" },

  { route: "/admin/presentation-interactive", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-presentation-interactive" },

  { route: "/admin/documents", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-documents" },

  { route: "/hanshi/instructeurs", auth: { username: "admin", role: "hanshi" }, testId: "page-hanshi-instructors" },

  { route: "/admin/dojos", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-dojos" },

  { route: "/hanshi/membres", auth: { username: "admin", role: "hanshi" }, testId: "page-hanshi-members" },
  { route: "/admin/etudiants", auth: { username: "admin", role: "hanshi" }, testId: "page-hanshi-members" },

  { route: "/admin/assistants", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-assistants" },

  { route: "/admin/parents", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-parents" },

  { route: "/admin/classes", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-classes" },

  { route: "/admin/evenements", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-evenements" },

  { route: "/admin/progression", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-progression" },

  { route: "/admin/comptes", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-comptes" },

  { route: "/admin/preparation-liste-officielle", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-preparation-liste" },

  { route: "/admin/roles", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-roles" },

  { route: "/admin/communications", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-communications" },

  { route: "/admin/shotokan-black-dragon", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-shotokan-black-dragon" },

  { route: "/sensei", auth: { username: "sensei", role: "sensei" }, testId: "page-sensei-dashboard" },

  { route: "/sempai", auth: { username: "sempai", role: "assistant" }, testId: "page-sempai-dashboard" },

  { route: "/mon-espace", auth: { username: "etudiant", role: "student" }, testId: "page-mon-espace" },

  { route: "/mes-cours", auth: { username: "etudiant", role: "student" }, testId: "page-mes-cours" },

  { route: "/parent", auth: { username: "parent", role: "parent" }, testId: "page-parent" },

  { route: "/parent/mes-enfants", auth: { username: "parent", role: "parent" }, testId: "page-parent-mes-enfants" },

  { route: "/devenir-membre", auth: null, testId: "page-devenir-membre" },

  { route: "/calendrier", auth: null, testId: "page-calendrier-public" },

  { route: "/black-dragon", auth: null, testId: "page-black-dragon-public" },

  { route: "/mon-adhesion", auth: { username: "etudiant", role: "student" }, testId: "page-mon-adhesion" },

  { route: "/mon-calendrier", auth: { username: "etudiant", role: "student" }, testId: "page-mon-calendrier" },

  { route: "/espace-black-dragon", auth: { username: "etudiant", role: "student" }, testId: "page-espace-black-dragon" },

  { route: "/admin/adhesions", auth: { username: "admin", role: "hanshi" }, testId: "page-admin-adhesions" },

  { route: "/parent/adhesion", auth: { username: "parent", role: "parent" }, testId: "page-parent-adhesion" },

];


